/*  Objects  */
import { User, UserIconAndName } from 'objects/User';

/*  React  */
import React from 'react';

export const UserIconAndNameCell = (props) => {
    const { row } = props;
    return (
        <User data={row.original}>
            <UserIconAndName link includeTitle />
        </User>
    );
};
